import { Logo } from 'components/layout/Logo.tsx';
import NavItems from 'components/layout/Navigation/components/NavItems.js';
import { ActiveLink } from 'components/ui';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const SideNavContainer = styled.div``;

const Wrapper = styled.div`
	background-color: white;
	.list-group-item {
		border: 0;
		padding-top: 0.75rem;
		padding-bottom: 0.75rem;
		color: var(--dunkelgrau);

		&.active {
			/* background-color: ${(props) => props.theme.contentBg}; */
			/* color: var(--themePrimary); */
			color: #414141;
			background-color: unset;
			text-decoration: none;
		}
	}
`;

const SideNav = () => {
	const [themePrimary, setThemePrimary] = useState('');

	useEffect(() => {
		const root = document.documentElement; // Or another element if it's scoped
		const styles = getComputedStyle(root);
		const color = styles.getPropertyValue('--themePrimary').trim();
		setThemePrimary(color);
	}, []);

	return (
		<Wrapper>
			<ActiveLink href='/'>
				<div className='position-relative' style={{ marginTop: '36px' }}>
					<img
						width='180px'
						src='/img/Logo_Frame.png'
						className='d-none d-xl-block mt-4'
					/>
					<div
						className='d-none d-xl-block position-absolute'
						style={{ top: '-10px', left: 0 }}
					>
						<Logo color={themePrimary} />
					</div>
				</div>
			</ActiveLink>
			<SideNavContainer
				className='d-none d-lg-block d-xl-block'
				style={{
					maxWidth: '200px',
					fontWeight: '600',
				}}
			>
				<NavItems />
			</SideNavContainer>
			<SideNavContainer
				className='d-block d-sm-block d-md-block d-lg-none mt-4'
				style={{
					marginLeft: '23px',
					marginTop: '30px',
					fontWeight: '600',
					paddingRight: '23px',
				}}
			>
				<NavItems />
			</SideNavContainer>
		</Wrapper>
	);
};

export default SideNav;
